import { EventType } from '@/models/event';

export default {
  values: {
    eventType: {
      [EventType.Injection]: 'Injection',
      [EventType.Inspection]: 'Inspection',
      [EventType.MissedInjection]: 'Missed Injection',
      [EventType.Note]: 'Note',
      [EventType.Operation]: 'Operation',
      [EventType.Physiotherapy]: 'Physiotherapy',
      [EventType.Sport]: 'Sport',
      [EventType.Visit]: 'Visit',
    },
    injectionReason: {
      prophylaxis: 'Prophylaxis',
      specialTreatment: 'Special Treatment',
      bleeding: 'Bleeding'
    },
    injectionBleedingBodyArea: {
      face: 'Face',
      forehead: 'Forehead',
      eye: 'Eye',
      nose: 'Nose',
      ear: 'Ear',
      mouth: 'Mouth',
      neck: 'Neck',
      chest: 'Chest',
      belly: 'Belly',
      hip: 'Hip',
      flank: 'Flank',
      genital: 'Genital',
      upper_back: 'Upper Back',
      lower_back: 'Lower Back',
      shoulder: 'Shoulder',
      upper_arm: 'Upper Arm',
      elbow: 'Elbow',
      forearm: 'Forearm',
      wrist: 'Wrist',
      hand: 'Hand',
      fingers: 'Fingers',
      thigh: 'Thigh',
      knee: 'Knee',
      leg: 'Leg',
      ankle: 'Ankle',
      sole: 'Sole',
      toes: 'Toes',
    },
    injectionBleedingBodySide: {
      left: 'Left',
      right: 'Right',
    },
    injectionBleedingType: {
      articular: 'Articular',
      skin: 'Skin',
      gums: 'Gums',
      custom: 'Other'
    },
    injectionBleedingReason: {
      spontaneous: 'Spontaneous',
      trauma: 'Trauma',
      custom: 'Other'
    },
    inspectionType: {
      hepatology: 'Hepatology',
      ortopedia: 'Ortopedia',
      virusImmunology: 'Virus Immunology',
      custom: 'Other',
    }
  }
}
